// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Libya */
const LY: PhoneNumberData = [218, 'LY', 9, '00-0000000'];

export default LY;
